var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayStoreBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1C",
  d: "M8 .5h104a7.5 7.5 0 0 1 7.5 7.5v24a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 32V8A7.5 7.5 0 0 1 8 .5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#383838",
  d: "M8 .5h104a7.5 7.5 0 0 1 7.5 7.5v24a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 32V8A7.5 7.5 0 0 1 8 .5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#play-store-badge_svg__a)",
  d: "M12.491 10.116c-.245.23-.327.612-.327 1.071v16.907c0 .459.164.841.409 1.07l.082.077 10.135-9.486v-.153z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#play-store-badge_svg__b)",
  d: "m26.062 22.968-3.351-3.136v-.23l3.351-3.136.082.076 4.005 2.142c1.145.612 1.145 1.607 0 2.219z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#play-store-badge_svg__c)",
  d: "m26.139 22.892-3.433-3.213-10.218 9.562c.409.383.981.383 1.717.077z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#play-store-badge_svg__d)",
  d: "m26.139 16.465-11.934-6.35c-.736-.382-1.308-.305-1.717.077l10.218 9.486z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m26.057 22.815-11.852 6.273c-.654.383-1.226.306-1.635 0l-.082.077.082.076c.409.306.98.383 1.635 0z",
  opacity: 0.2
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.491 29.088c-.245-.23-.327-.612-.327-1.07v.076c0 .459.164.841.409 1.07v-.076zm17.656-8.415-4.087 2.142.082.077 4.005-2.142c.572-.306.818-.689.818-1.071 0 .382-.328.688-.818.994",
  opacity: 0.12
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m14.208 10.193 15.94 8.491c.49.306.817.612.817.995 0-.383-.246-.765-.818-1.071l-15.94-8.492c-1.144-.612-2.043-.153-2.043 1.071v.077c0-1.148.9-1.683 2.044-1.071",
  opacity: 0.25
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M41.06 10.03c-.755 0-1.413.247-1.939.74q-.789.738-.789 1.845 0 1.108.79 1.846c.525.493 1.183.739 1.939.739 1.052 0 1.94-.523 2.4-1.323V12.46h-2.433v.708h1.578v.554c-.362.523-.855.77-1.545.77-.56 0-1.02-.185-1.381-.524-.362-.369-.526-.8-.526-1.354 0-.523.164-.984.526-1.323.329-.338.789-.523 1.348-.523.657 0 1.15.277 1.545.8l.592-.492c-.46-.677-1.184-1.046-2.104-1.046M44.516 10.123v5.015H48v-.707h-2.663v-1.6h1.94v-.708h-1.94v-1.292h2.564v-.708zM48.43 10.123v.708h1.742v4.307h.822v-4.307h1.742v-.708zM55.332 10.123v5.015h.822v-5.015zM56.941 10.123v.708h1.743v4.307h.822v-4.307h1.742v-.708zM66.21 10.03c-.757 0-1.414.247-1.94.74q-.79.738-.79 1.845 0 1.108.79 1.846c.526.493 1.15.739 1.94.739.755 0 1.38-.246 1.906-.739q.79-.738.79-1.846 0-1.107-.79-1.846c-.493-.492-1.15-.738-1.907-.738m0 .74c.525 0 .986.184 1.314.522.362.339.526.8.526 1.323 0 .554-.164.985-.526 1.323a1.85 1.85 0 0 1-1.315.523c-.526 0-.986-.184-1.315-.523-.362-.369-.526-.8-.526-1.323s.165-.984.526-1.323a1.85 1.85 0 0 1 1.315-.523M73.349 13.508l-3.123-3.477h-.296v5.108h.822v-3.385l3.156 3.477h.296v-5.108h-.822v3.385zM43.1 18.861c-1.349 0-2.467.431-3.387 1.323q-1.38 1.293-1.381 3.231 0 1.94 1.38 3.23c.921.863 2.04 1.293 3.387 1.293 1.808 0 3.42-.923 4.208-2.307v-2.462h-4.24v1.262h2.794v.953c-.625.893-1.512 1.323-2.696 1.323-.986 0-1.775-.307-2.4-.923-.625-.615-.92-1.415-.92-2.369q0-1.384.887-2.307c.592-.616 1.38-.924 2.334-.924 1.118 0 2.039.462 2.696 1.385l1.052-.83c-.855-1.262-2.104-1.878-3.715-1.878M51.453 21.107c-.986 0-1.841.339-2.532.985-.69.646-1.019 1.477-1.019 2.43 0 .955.33 1.785 1.02 2.432.69.646 1.512.984 2.531.984.986 0 1.808-.338 2.531-.984.69-.677 1.053-1.477 1.053-2.431s-.362-1.785-1.053-2.431c-.69-.646-1.545-.985-2.531-.985m.033 1.293c.592 0 1.085.215 1.48.615.394.4.591.892.591 1.508 0 .584-.197 1.108-.592 1.508s-.887.584-1.48.584c-.59 0-1.084-.184-1.478-.584-.395-.4-.592-.924-.592-1.508 0-.616.197-1.108.592-1.508.361-.43.854-.615 1.479-.615M59.113 21.107c-.986 0-1.84.339-2.531.985-.69.646-1.02 1.477-1.02 2.43 0 .955.33 1.785 1.02 2.432.69.646 1.512.984 2.531.984.986 0 1.808-.338 2.532-.984.69-.677 1.052-1.477 1.052-2.431s-.362-1.785-1.052-2.431-1.546-.985-2.532-.985m.033 1.293c.592 0 1.085.215 1.48.615.394.4.591.892.591 1.508 0 .584-.197 1.108-.591 1.508-.395.4-.888.584-1.48.584s-1.085-.184-1.48-.584c-.394-.4-.591-.924-.591-1.508 0-.616.197-1.108.592-1.508.361-.43.854-.615 1.48-.615M68.942 22.184c-.526-.707-1.315-1.077-2.367-1.077-.953 0-1.71.308-2.334.924-.625.615-.92 1.384-.92 2.369 0 .954.328 1.754.92 2.369.624.615 1.38.923 2.334.923.986 0 1.71-.308 2.269-.923v.462c0 1.23-.79 1.876-2.006 1.876q-1.184 0-2.367-.923l-.789.985c.888.83 1.973 1.23 3.222 1.23 2.038 0 3.353-1.169 3.353-3.23v-5.846h-1.315zm-2.137 4.246a2.14 2.14 0 0 1-1.48-.553q-.591-.6-.591-1.477t.592-1.477q.592-.554 1.48-.554c1.117 0 2.038.677 2.038 2 0 .677-.198 1.17-.592 1.538-.428.339-.888.523-1.447.523M71.64 17.815v9.97h1.447v-9.97zM80.648 24.093c0-.862-.296-1.57-.888-2.154-.592-.585-1.315-.862-2.203-.862-.986 0-1.808.339-2.465.985-.658.646-.986 1.477-.986 2.43 0 .985.328 1.785 1.019 2.431s1.545.985 2.597.985c1.02 0 1.907-.338 2.696-1.046l-.69-.954c-.592.523-1.25.77-1.973.77-1.15 0-2.006-.647-2.203-1.724h4.997c.066-.277.099-.585.099-.861m-3.156-1.785c.986 0 1.71.615 1.71 1.6h-3.65c.23-.985.986-1.6 1.94-1.6M84.856 19.016v8.769h1.446V24.4h1.841c.92 0 1.644-.246 2.236-.738.559-.492.855-1.17.855-1.97s-.296-1.446-.855-1.938c-.56-.492-1.315-.738-2.236-.738zm3.287 1.23c1.02 0 1.611.585 1.611 1.447 0 .861-.592 1.446-1.61 1.446h-1.81v-2.893zM92.055 17.815v9.97H93.5v-9.97zM97.48 21.107c-1.217 0-2.17.462-2.828 1.385l.822.83c.559-.645 1.183-.984 1.874-.984.92 0 1.447.492 1.447 1.385v.43h-1.907c-1.513 0-2.466.739-2.466 1.878s.92 1.876 2.334 1.876c.92 0 1.644-.307 2.137-.892v.739h1.348v-3.939c0-1.723-1.085-2.708-2.762-2.708m-.428 5.754c-.69 0-1.184-.307-1.184-.861 0-.523.395-.8 1.184-.8h1.71v.123c.032.892-.757 1.538-1.71 1.538M104.251 26.03l-1.94-4.768h-1.545l2.696 6.246-.264.615c-.328.739-.789.954-1.479.954-.099 0-.362 0-.789-.061v1.169c.362.092.756.123 1.118.123 1.15 0 1.907-.554 2.466-1.785l3.287-7.261h-1.545z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "play-store-badge_svg__a",
  x1: 21.809,
  x2: 8.998,
  y1: 11.042,
  y2: 24.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "play-store-badge_svg__b",
  x1: 31.648,
  x2: 11.87,
  y1: 19.68,
  y2: 19.68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "play-store-badge_svg__c",
  x1: 24.281,
  x2: 6.909,
  y1: 21.435,
  y2: 39.997,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "play-store-badge_svg__d",
  x1: 9.952,
  x2: 17.71,
  y1: 4.513,
  y2: 12.802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.069,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})))));
export default SvgPlayStoreBadge;